import React from "react";
import Login from "components/Login";

export default function LoginPage() {
  return <>
    <div className="App-login">
      <h3>Sign in to Giffy</h3>
      <Login />
    </div>
  </>
}
